import request from '@/utils/request'

let Pick_cotton_imageApi = {

  /*采棉机图片管理列表*/
  list(data) {
    return request._post('/shop/plus.pick_cotton_image.Index/index', data);
},
/*添加采棉机图片管理*/
add(data) {
    return request._post('/shop/plus.pick_cotton_image.Index/add', data);
},
/*修改采棉机图片管理*/
edit(data) {
    return request._post('/shop/plus.pick_cotton_image.Index/edit', data);
},
/*删除采棉机图片管理*/
del(data) {
    return request._post('/shop/plus.pick_cotton_image.Index/del', data);
},
/*采棉机图片管理详情*/
detail(data) {
  return request._post('/shop/plus.pick_cotton_image.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.pick_cotton_image.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.pick_cotton_image.Setting/getSetting', data, errorback);
    },
}
export default Pick_cotton_imageApi;



// WEBPACK FOOTER //
// ./src/api/pick_cotton_image.js